import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import urls from 'utils/config';
import { SUCCESS, TOP_RIGHT } from 'utils/constants';
import { networkErrorHandler } from 'utils/errrorHandlers';
import request from 'utils/request';
import {
  fetchInterswitchConfig,
  fetchNabrollConfig,
  fetchPayproKanoConfig,
  fetchPaystackConfig,
  fetchPayUnimaidConfig,
  fetchRemitaConfig,
  fetchSokotoIrsConfig,
  fetchPaymentConfig,
  importBankAccountsFailure,
  importBankAccountsSuccess,
} from '../actions';
import paymentConfigTypes from '../types';

const { API_BASE_URL } = urls || {};

function* importPaymentConfig({ payload: { id, cb } }) {
  const url = `${API_BASE_URL}/paylog-configurations`;
  const data = {
    configId: id,
  };
  const response = yield request({
    method: 'post',
    data,
    url,
  });
  if (response.success) {
    const platform =
      typeof response.raw.paymentPlatform === 'string'
        ? response.raw.paymentPlatform
        : response.raw.paymentPlatform?.id;
    if (platform === 'REMITA') {
      yield put(fetchRemitaConfig([response.raw.id]));
    } else if (platform === 'PAYSTACK') {
      yield put(fetchPaystackConfig([response.raw.id]));
    } else if (platform === 'NABROLL') {
      yield put(fetchNabrollConfig([response.raw.id]));
    } else if (platform === 'PAYPRO_KANO') {
      yield put(fetchPayproKanoConfig([response.raw.id]));
    } else if (platform === 'PAYUNIMAID') {
      yield put(fetchPayUnimaidConfig([response.raw.id]));
    } else if (platform === 'SOKOTO_IRS') {
      yield put(fetchSokotoIrsConfig([response.raw.id]));
    } else {
      yield put(fetchInterswitchConfig([response.raw.id]));
    }
    yield put(fetchPaymentConfig());
    cb(platform);
    yield put(importBankAccountsSuccess());
    Notify(`${platform} bank accounts imported successfully`, {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
  } else {
    yield put(
      importBankAccountsFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    if (response.statusCode === 400) {
      networkErrorHandler(response?.statusCode, 'Invalid paylog ID');
    } else if (response.statusCode === 409) {
      networkErrorHandler(
        response?.statusCode,
        'Provided paylog id already exists'
      );
    } else {
      networkErrorHandler(
        response?.statusCode,
        'An error occured. Please reload the page to try again.'
      );
    }
  }
}

export function* onImportPaymentConfig() {
  yield takeLatest(
    paymentConfigTypes.IMPORT_PAYMENT_CONFIG_REQUEST,
    importPaymentConfig
  );
}
